import { CustomInformationElement } from './CustomInformationElement';
import { InformationElementSortOrders } from './InformationElementSortOrders';
import { Video } from './Video';
import { JobDescription } from './JobDescription';
import { CompanyDescription } from './CompanyDescription';

export class JobModel {
  applicationDeadline: Date;
  autoRefresh1PostedDate: Date;
  autoRefresh2PostedDate: Date;
  benefits: Array<string>;
  companyDescription: string;
  companyDescriptions: Array<CompanyDescription>;
  compensationRange: string;
  customElements: Array<CustomInformationElement>;
  departmentName: string;
  description: string;
  displayApplicationDeadline: boolean;
  displayPostedDate: Date;
  employmentType: string;
  experience: string;
  fullLocation: any;
  googleMapsApiKey: string;
  id: number;
  informationElementSortOrders: InformationElementSortOrders;
  instanceName: string;
  jobDescriptions: Array<JobDescription>;
  location: string;
  postedDate: Date;
  remoteStatus: string;
  title: string;
  videos: Array<Video>;
  compensation: Compensation;
  
  setDisplayPostedDate() {
    const now = new Date();
    if (this.autoRefresh2PostedDate && new Date(this.autoRefresh2PostedDate) < now) {
      this.displayPostedDate = new Date( this.autoRefresh2PostedDate);
    } else if (this.autoRefresh1PostedDate && new Date(this.autoRefresh1PostedDate) < now) {
      this.displayPostedDate = new Date(this.autoRefresh1PostedDate);
    } else {
      this.displayPostedDate = this.postedDate;
    }
  }
}

export class Compensation {
  type: string;
  min: number;
  max: number;
  period: string;
}
